import { BookmarkModel } from '../models/bookmark.model';
import { BookmarkSortModel } from '../models/bookmark-sort.model';
import { GalleryViewMode } from 'src/app/gallery/models/gallery-view-mode.enum';

export class BookmarksStateModel {
    loading: boolean;
    exporting: boolean;
    copying: boolean;
    saving: boolean;
    bookmarks: BookmarkModel[];
    selectedBookmark?: BookmarkModel;
    sort: BookmarkSortModel;
    checkedBookmarks: string[];
    selectedCategory?: 'individual' | 'organization' | 'collection';
}
